var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Alert as MuiAlert, styled } from '@mui/material';
import { Close16 } from '@yunex/yds-icons';
import StatusError16 from '@yunex/yds-icons/components/StatusError16';
import StatusInfo16 from '@yunex/yds-icons/components/StatusInfo16';
import StatusSuccess16 from '@yunex/yds-icons/components/StatusSuccess16';
import StatusWarning16 from '@yunex/yds-icons/components/StatusWarning16';
import React, { forwardRef } from 'react';
import Button from '../Button/Button';
var SMuiAlert = styled(MuiAlert, {
    name: 'MuiAlert',
    overridesResolver: function (_a) {
        var severity = _a.severity, theme = _a.theme, size = _a.size;
        var customOverrides = theme.components.MuiAlert.customOverrides;
        return [
            severity === undefined && [customOverrides.general],
            size === 'small' && [customOverrides.small],
        ];
    },
})({});
var CloseButton = function (props) { return (React.createElement(Button, __assign({ size: "small", color: "inherit", icon: true }, props),
    React.createElement(Close16, null))); };
var Alert = forwardRef(function (_a, ref) {
    var _b = _a.severity, severity = _b === void 0 ? 'general' : _b, props = __rest(_a, ["severity"]);
    return (React.createElement(SMuiAlert, __assign({}, props, { severity: severity === 'general' ? undefined : severity, iconMapping: {
            success: React.createElement(StatusSuccess16, null),
            info: React.createElement(StatusInfo16, null),
            warning: React.createElement(StatusWarning16, null),
            error: React.createElement(StatusError16, null),
        }, slots: {
            closeButton: CloseButton,
        }, ref: ref })));
});
Alert.displayName = 'Alert';
export default Alert;
